import { Box, Link, Paper, Typography } from '@mui/material';
import { NavLinkComponent } from '../../Router';
import { ColumnData, DataListComponent, NoDataPaper } from "../../components/data/DataTable";
import { PersonListDto, personListColumns } from "../../components/person/PersonList";
import Logo from '../../icons/Logo';
import HouseCombo, { houseStore } from "../houses/HouseCombo";


export const inhabitantListColumns: ColumnData<PersonListDto>[] = personListColumns.filter(x => x.name !== 'CreateDate');
inhabitantListColumns.splice(2, 0, {
    width: 120,
    label: 'Дом(а)',
    name: 'HouseIds',
    type: 'array',
    store: houseStore,
    filter: (onChange) => <HouseCombo onChange={e => onChange(e.target.value)} />,
    renderer: (val, obj) => (val as number[])?.map(v => houseStore.data?.filter(x => x.Id == v).map(x => x.Value)).join(', ')
});

const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildPersonListDtoListItem(x: PersonListDto) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['page', 'inhabitant'], ['id', x.Id]]}>
        <Box display="flex" flexDirection="column" minWidth={80} gap={.5} flex={1}>
            <Link variant="h3">{x.fio}</Link>
            <Typography variant="subtitle2">{x.HouseIds?.map(v => houseStore.data?.filter(x => x.Id == v).map(x => x.Value)).join(', ')}</Typography>
        </Box>
        <Box>
            <Typography variant="h3" textAlign="left">{x.contacts}</Typography>
        </Box>
        <Box>
            {x.UserId ? <div style={{
                height: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%'
            }}><Logo style={{ height: '100%' }} /></div> : null}
        </Box>
    </Paper>;
}

export function noDataRenderer() {
    return <NoDataPaper title="Заявок пока нет" content={['В этом разделе вы можете создавать заявки к УК на оказание услуг']} />;
}

export default class InhabitantList extends DataListComponent<PersonListDto> {
    renderNoData() {
        return noDataRenderer();
    }

    buildItemPaper(x: PersonListDto, i: number) {
        return buildPersonListDtoListItem(x);
    }
}